module.exports = __webpack_public_path__ + "static/media/Kyla27491024.2a6bcda1.png";